import { View, useWindowDimensions } from 'react-native'
import React from 'react'
import { Image } from 'expo-image'
import { StyleSheet, useUnistyles } from 'react-native-unistyles'
import SolidButton from '@/components/General/SolidButton'
import usePlatform from '@/utils/hooks/usePlatform'
import { useRouter } from 'expo-router'

export default function NotFound() {
    const router = useRouter();
    const { rt: { themeName } } = useUnistyles();
    const { isLandscape } = usePlatform();
    const { width } = useWindowDimensions();

    const imgWidth = width * (isLandscape ? 0.5 : 1.0);
    const source = themeName === 'light' ? require('@/assets/bear/404_light.png') : require('@/assets/bear/404_dark.png');
    const bgColor = themeName === 'light' ? '#FDFDFD' : '#02060F';

    return (
      <View style={[styles.container, { backgroundColor: bgColor }]}>
        <Image
            source={source}
            style={{ width: imgWidth, aspectRatio: 1536 / 1024 }}
            contentFit="contain"
        />
        <SolidButton
            text="Go Back"
            variant="muted"
            onPress={() => router.canGoBack() ? router.back() : router.replace("/")}
        />
      </View>
    )
}

const styles = StyleSheet.create(() => ({
    container: {
        flex: 1,
        minHeight: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 0,
        gap: 24,
    },
}));
